import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
var propTypes = {
  /**
   * @ignore
   */
  size: PropTypes.string,

  /**
   * @ignore
   */
  secondary: PropTypes.bool,

  /**
   * @ignore
   */
  showDialog: PropTypes.bool,

  /**
   * @ignore
   */
  hovered: PropTypes.bool,

  /**
   * @ignore
   */
  activeStyleState: PropTypes.bool,

  /**
   * @ignore
   */
  type: PropTypes.string
};
var defaultProps = {
  secondary: false,
  showDialog: false,
  hovered: false,
  activeStyleState: false,
  type: null
};
/**
 * @ignore
 */

var AnchorIconBase = /*#__PURE__*/styled.button.withConfig({
  displayName: "AnchorIconBase",
  componentId: "sc-1liec79-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  background: none;\n  color: inherit;\n  cursor: ", ";\n  transition-delay: 0.2s;\n  overflow: visible;\n  left: ", ";\n  position: relative;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
}, calculateRem(4), function (_ref2) {
  var keyboardFocused = _ref2.keyboardFocused;
  return !keyboardFocused && "\n    outline: none;\n\n  ";
}, function (_ref3) {
  var showDialog = _ref3.showDialog,
      secondary = _ref3.secondary,
      size = _ref3.size,
      type = _ref3.type,
      inverted = _ref3.inverted,
      keyboardFocused = _ref3.keyboardFocused,
      focusState = _ref3.focusState;
  return !showDialog && !inverted && !focusState && keyboardFocused && "\n\n    &:focus {\n        border: 1px solid transparent;\n        outline: 1px dotted black;\n        outline: auto 2px Highlight;\n        outline: -webkit-focus-ring-color auto 5px;\n    }\n\n  ";
}, function (_ref4) {
  var keyboardFocused = _ref4.keyboardFocused,
      focusState = _ref4.focusState,
      inverted = _ref4.inverted,
      colorConfig = _ref4.colorConfig;
  return focusState && keyboardFocused && "\n    &:focus {\n      outline: none;\n        &::before {\n          border: ".concat(calculateRem(1), " dashed ").concat(inverted ? colorConfig.white : colorConfig.black, ";\n          border-radius: 50%;\n          content: '';\n          height: calc(100% + ").concat(calculateRem(2), ");\n          left: 50%; \n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat(calculateRem(2), ");\n        }\n    }\n  ");
}, function (_ref5) {
  var secondary = _ref5.secondary,
      type = _ref5.type,
      colorConfig = _ref5.colorConfig;
  return (secondary || type === 'secondary') && "\n    fill: ".concat(colorConfig.white, ";\n  ");
}, function (_ref6) {
  var hovered = _ref6.hovered,
      secondary = _ref6.secondary,
      size = _ref6.size,
      type = _ref6.type,
      inverted = _ref6.inverted;
  return hovered && !inverted && " \n       &:focus,\n       &.focus-visible {\n        &::after {\n          border: none;\n          outline: none;\n        }\n      }\n    ";
});
AnchorIconBase.propTypes = propTypes;
AnchorIconBase.defaultProps = defaultProps;
export default AnchorIconBase;